export const topmenus = [
   {
      id:0,
      path: '/',
      name: 'Home',
      exact: true,
      component: null
   },
   {
      id:1,
      path: '/login',
      name: 'Login',
      exact: true,
      component: null
   },
   {
      id:2,
      path: '/register',
      name: 'Register',
      exact: true,
      component: null
   },
   {
      id:3,
      path: '/profile',
      name: 'Profile',
      exact: true,
      component: null
   },
   {
      id:4,
      path: '/transaction',
      name: 'Transaction',
      exact: true,
      component: null
   },
   {
      id:5,
      path: '/cart',
      name: 'Cart',
      exact: true,
      component: null
   },
   {
      id:6,
      path: '/checkout',
      name: 'Checkout',
      exact: true,
      component: null
   },
   {
      id:7,
      path: '/program',
      name: 'Program',
      exact: true,
      component: null
   },
   {
      id:8,
      path: '/payment',
      name: 'Payment',
      exact: true,
      component: null
   },
   {
      id:9,
      path: '/integration',
      name: 'Integration',
      exact: true,
      component: null
   },
   {
      id:10,
      path: '/report',
      name: 'Report',
      exact: true,
      component: null
   }
]